module.exports = __webpack_public_path__ + "static/media/2val.501108e8.png";